import useViewerStore from "@/stores/useViewerStore";
import { Network } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Toggle } from "../ui/toggle";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

const ObjectViewsButton = () => {
    const { modelBrowserOpen, toggleModelBrowser } = useViewerStore();
    const { t } = useTranslation();

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <div>
                    <Toggle
                        aria-label={t("objectViewsButton.toggleTree")}
                        className="mr-1"
                        pressed={modelBrowserOpen}
                        onPressedChange={toggleModelBrowser}
                    >
                        <Network />
                    </Toggle>
                </div>
            </TooltipTrigger>
            <TooltipContent>
                <p>{t("objectViewsButton.modelBrowser")}</p>
            </TooltipContent>
        </Tooltip>
    );
};

export default ObjectViewsButton;
